// extracted by mini-css-extract-plugin
export default {"admin-content":"Admin_admin-content__V1zIG"};